import axios from "../auth/FetchInterceptor";

export const getAllDisputes = async ({
    page = 1,
    limit = 10,
    search = "",
    status = ""
}) => {
    const response = await axios.get('/disputes/admin', {
        params: { page, limit, search, status },
    });
    return response.data;
};

export const updateDisputeStatus = async (id, status) => {
    const response = await axios.put(`/disputes/${id}`, { status });
    return response.data;
};

export const deleteDispute = async (id) => {
    const response = await axios.delete(`/disputes/${id}`);
    return response.data;
};
